<div class="priceListLanding">
  <div class="nplLanding priceList-wrapper" style="width: 100%; margin:0;">
    <div class="priceListLandingPage  margin-0">
      <div class="topSection">
        <div class="alignTopSec">
          <div class="row">
            <div class="col-lg-8 col-md-8">
              <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item active">
                      <a href="javascript:void(0)" routerLink="/cpp/customer-price-list">Price Lists</a>
                      <i class="fas fa-angle-right"></i>
                    </li>
                    <li class="breadcrumb-item breadcrumbColor">
                      <a href="javascript:void(0)" routerLink="/cpp/price-list-dashboard/{{accountNo}}">{{accountName}}</a>
                    </li>
                    <li class="breadcrumb-item breadcrumbColor margin-l-rem">
                      <i class="fas fa-angle-right"></i>
                    </li>
                    <li class="breadcrumb-item breadcrumbColor">
                      <span>Manage Subscriptions</span>
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 text-right">
              <div class="subscribe-sec">
                <div class="status">
                  My Status
                  <span *ngIf="isStatus == 'Subscribed'" class="" (click)="showHideSubscription()">{{ this.isStatus }}</span>
                  <span *ngIf="isStatus != 'Subscribed'" class="redColor" (click)="showHideSubscription()">{{ this.isStatus }}</span>
                </div>
                <div class="tab-content" *ngIf="isSubsModalShow" appClickOutside (clickOutside)="closePopup()">
                  <div class="salesPersonOuter" [ngStyle]="{'width':changesOnly === 'Y' ? '1000px' : '500px' }">
                    <div class="tab-content-heading headtabPadding">
                      For: {{this.accountName}}
                    </div>
                    <div class="tab-content-detail">
                      <p>
                        Do you want to
                        <span *ngIf="isStatus == 'Subscribed'" class="redColor"> Update </span>
                        <span *ngIf="isStatus != 'Subscribed'" class="otherColor"> Subscribe </span>
                        {{isStatus == 'Subscribed' ? "your subscription preferences?": "to this price list?"}}
                      </p>
                      <div class="displayInline">
                        <div class="showChangesSection width-switch1 option">
                          <div class="row">
                            <div [ngClass]="changesOnly === 'Y' ? 'col-3': 'col-6'" class="padding-r0">
                              <div class="row">
                                <div class="col-8">SHOW CHANGES ONLY: <b> {{ changesOnly === "Y" ? "ON" : "OFF" }}</b> </div>
                                <label class="switch">
                                  <input type="checkbox" (click)="toggleForchangesOnlyPopup()" [checked]="changesOnly == 'Y'">
                                  <span class="slider round"></span>
                                </label>
                              </div>
                            </div>

                            <div class="col-5" *ngIf="changesOnly == 'Y' ? true : false">
                              <div class="row">
                                <div class="col-6">
                                  <div class="row">
                                    <span class="col-8 padding-r0">TERM CHANGES ONLY: <b> {{ termchangesOnly === "Y" ? "ON" : "OFF" }}</b> </span>
                                    <label class="switch">
                                      <input type="checkbox" (click)="toggleForTermChangesOnly()" [checked]="termchangesOnly=='Y'">
                                      <span class="slider round"></span>
                                    </label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="row">
                                    <span class="col-8 padding-r0">PRICE CHANGES ONLY: <b> {{ pricechangesOnly === "Y" ? "ON" : "OFF" }}</b> </span>
                                    <label class="switch">
                                      <input type="checkbox" (click)="toggleForPriceChangesOnlyPopup()" [checked]="pricechangesOnly=='Y'">
                                      <span class="slider round"></span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div *ngIf="headerCompany !== masterConstants.US_COMPANYCODE" class="col-4">
                              <div class="row">
                                <div class="col-8">DISPLAY: <b> {{ subscriptionType === "C" ? "SPECIAL PRICED ITEMS" : "ALL ITEMS" }}</b> </div>
                                <label class="switch">
                                  <input type="checkbox" (click)="toggleForSpecialItemDisplayPopup()" [checked]="subscriptionType == 'C'">
                                  <span class="slider round"></span>
                                </label>
                              </div>
                            </div>

                            <div *ngIf="headerCompany === masterConstants.US_COMPANYCODE" class="padding-r0" [ngClass]="changesOnly === 'Y' ? 'col-4': 'col-6'">
                              <div class="row">

                                <div class="col-8">
                                  DISPLAY: <b>
                                    {{subscriptionType === "A" ? "ALL ITEMS" : subscriptionType === "F" ? "FAVORITE ITEMS" : subscriptionType === "C" ? "SPECIAL PRICED ITEMS" :"UNKNOWN SUBSCRIPTION TYPE"}}
                                  </b>
                                </div>
                                <section class="switch" [id]="mySubscriptionDisplayItemToggle">
                                  <mat-slide-toggle class="example-margin" (click)="changeForMySubscription()">
                                  </mat-slide-toggle>
                                </section>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="displayInline row">
                        <div class="allItemsSection width-switch3 option" [ngClass]="changesOnly === 'Y' ? 'col-3': 'col-4'">
                          <div class="row">
                            <div class="col-8">DISPLAY APR: <b> {{ displayAPR === "Y" ? "ON" : "OFF" }}</b> </div>
                            <label class="switch position-switch3">
                              <input type="checkbox" (click)="toggleForDisplayAPRPopup()" [checked]="displayAPR == 'Y'">
                              <span class="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="btn-sec margin-t20">
                        <button mat-raised-button class="btns normal-large-btn margin-r15" (click)="isStatus == 'Subscribed' ? changeStatus(true): changeStatus();" color="primary"> {{isStatus == 'Subscribed' ? "Update": "Subscribe"}}</button>
                        <button mat-raised-button class="btns normal-large-btn" (click)="closePopup()" color="primary">Cancel</button>
                        <button *ngIf="isStatus == 'Subscribed'" mat-raised-button class="btns normal-large-btn xs-ml-15" (click)="changeStatus();" color="primary">Unsubscribe</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-sec">
            <div class="row margin-b10 margin-r0 margin-l0 ">
              <div class="col-md-12 col-lg-12 smallPadRgt0 padding-l0">
                <div class="row search-box-outer ">
                  <div class="col-md-3 col-lg-2 padding-r0 catgory-drop-outer">
                    <div class="category-dropdown material-select">
                      <ng-select name="ddlPLManageSubscription"
                                 [items]="searchTypeList"
                                 [(ngModel)]="selectedFilter"
                                 [virtualScroll]="true"
                                 [closeOnSelect]="true"
                                 [selectOnTab]="true"
                                 [clearable]="false"
                                 bindLabel="label"
                                 bindValue="column"
                                 [searchable]="false">
                      </ng-select>
                    </div>
                  </div>
                  <div class="col-md-7 col-lg-8 borderLeft padding-l4 padding-r0 searchRtSection">
                    <div class="row material-select reports-search-filter">
                      <ng-select *ngIf="selectedFilter=='User Name'"
                                 name="ddlUserNameSearch"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [items]="userNameList"
                                 [(ngModel)]="filtersValue.userName"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 (change)="keepFilter()">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for ""
                          </div>
                        </ng-template>
                      </ng-select>
                      <ng-select *ngIf="selectedFilter=='User Id'"
                                 name="ddlUserIdSearch"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [items]="userIdList"
                                 [(ngModel)]="filtersValue.userId"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 (change)="keepFilter()">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for ""
                          </div>
                        </ng-template>
                      </ng-select>
                      <ng-select *ngIf="selectedFilter=='Email Id'"
                                 name="ddlEmailIdSearch"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [items]="emailList"
                                 [(ngModel)]="filtersValue.emailId"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 (change)="keepFilter()">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for ""
                          </div>
                        </ng-template>
                      </ng-select>
                      <ng-select *ngIf="selectedFilter=='Price Change Only'"
                                 name="ddlPriceChangeSearch"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [items]="priceChangeOnlyList"
                                 [(ngModel)]="filtersValue.priceChangeOnly"
                                 [multiple]="false"
                                 [hideSelected]="true"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 (change)="keepFilter()">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for ""
                          </div>
                        </ng-template>
                      </ng-select>
                      <ng-select *ngIf="selectedFilter=='Subscription Type'"
                                 name="ddlSubscriptionTypeSearch"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [items]="subscriptionTypeList"
                                 [(ngModel)]="filtersValue.subscriptionType"
                                 [multiple]="false"
                                 [hideSelected]="true"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="value"
                                 [closeOnSelect]="true"
                                 (change)="keepFilter()">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for ""
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="col-md-2 col-lg-2 search-btn-outer text-right padding-0">
                    <div class="search-btn">
                      <button mat-raised-button class="btns" (click)="filterData();" color="primary">Filter</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="chips-sec">
                  <div class="row selected-chip">
                    <div class="col-md-10 col-lg-10 padding-l0 padding-r0 ">
                      <div>
                        <mat-chip-set>
                          <mat-chip selected *ngFor="let filterValue of filterValueList">
                            {{filterValue.filterlabel}}
                            <a href="Javascript:void(0);" (click)="clearFilter(filterValue.column)">
                              <i class="fas fa-times text-right"></i>
                            </a>
                          </mat-chip>
                        </mat-chip-set>
                      </div>
                    </div>
                    <div class="col-md-2 col-lg-2 text-right padding-r30" *ngIf="filterValueList.length > 0">
                      <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row padding-r15 topSecBtn">
              <div class="col-md-2 col-lg-2 col-xl-2 padding-l0 ">
                <div class="listing-action-items manage-subs">
                  <div class="selectAllcheckSec pl-2" *ngIf="plManageSubDataSource && plManageSubDataSource.data.length > 0">
                    <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                                  [checked]="totalEditableRows > 0 && (selectedCount > 0) && (selectedCount == totalEditableRows)"
                                  [indeterminate]="totalEditableRows > 0 && (selectedCount > 0) && (selectedCount < totalEditableRows)"
                                  [style.display]="'block'"
                                  (change)="enableAllCheckBoxes(Allcheck._checked);"
                                  matTooltip="Select All Lines" [matTooltipPosition]="'above'"></mat-checkbox>

                    <i class="fas fa-sort-down light-gray-arrow" aria-hidden="true"></i>
                  </div>
                  <div class="action-links display-ib" *ngIf="editToolKit">
                    <div class="display-ib">

                      <span class="margin-l5 circular-btn firstOne icons" mat-button matTooltip="Subscribe" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" (click)="showHideSubsWindow()">
                        <img class="" src="../assets/images/add_email.png" alt="Subscribe" />
                      </span>

                      <span class="margin-l5 circular-btn thirdOne context-menu icons" mat-button matTooltip="Unsubscribe" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" (click)="showHideUnSubsWindow()">
                        <img class="" src="../assets/images/do_not_contact.png" alt="Unsubscribe" />
                      </span>

                      <div class="tab-content smallSubsWindow" *ngIf="isSubsBtnModalShow" appClickOutside (clickOutside)="closeSubscribePopup()">
                        <div class="salesPersonOuter" [ngStyle]="{'width':bulkChangesOnly === 'Y' ? '900px' : '460px' }">
                          <div class="tab-content-heading headtabPadding">
                            For: {{this.accountName}}
                          </div>
                          <div class="tab-content-detail">
                            <p>
                              Are you sure you want to
                              <span *ngIf="isSubscribeBulk" class="otherColor"> Subscribe </span>
                              <span *ngIf="!isSubscribeBulk" class="redColor"> Unsubscribe</span>
                              selected {{this.selectedCount}} user(s)?
                            </p>
                            <div class="displayInline" *ngIf="isSubscribeBulk">
                              <div class="showChangesSection width-switch1 option">
                                <div class="row">
                                  <div [ngClass]="bulkChangesOnly === 'Y' ? 'col-3': 'col-6'" class="padding-r0">
                                    <div class="row">
                                      <span class="col-8">SHOW CHANGES ONLY: <b> {{ bulkChangesOnly == "Y" ? "ON" : "OFF" }}</b> </span>
                                      <label class="switch">
                                        <input type="checkbox" (click)="toggleForchangesOnlyBulkSubPopup()" [checked]="bulkChangesOnly == 'Y'">
                                        <span class="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div class="col-5" *ngIf="bulkChangesOnly == 'Y' ? true : false">
                                    <div class="row">
                                      <div class="col-6 padding-r0">
                                        <div class="row">
                                          <div class="col-8 padding-r0">TERM CHANGES ONLY: <b> {{ termchangesOnly === "Y" ? "ON" : "OFF" }}</b> </div>
                                          <label class="switch">
                                            <input type="checkbox" (click)="toggleForTermChangesOnly()" [checked]="termchangesOnly=='Y'">
                                            <span class="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                      <div class="col-6 padding-r0">
                                        <div class="row">
                                          <div class="col-8 padding-r0">PRICE CHANGES ONLY: <b> {{ pricechangesOnly === "Y" ? "ON" : "OFF" }}</b> </div>
                                          <label class="switch">
                                            <input type="checkbox" (click)="toggleForPriceChangesOnlyPopup()" [checked]="pricechangesOnly=='Y'">
                                            <span class="slider round"></span>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div *ngIf="headerCompany !== masterConstants.US_COMPANYCODE" class="col-4">
                                    <div class="row">
                                      <span class="col-8">DISPLAY: <b> {{ bulkSubscriptionType == "C" ? "SPECIAL PRICED ITEMS" : "ALL ITEMS" }}</b> </span>
                                      <label class="switch ">
                                        <input type="checkbox" checked>
                                        <span class="slider round" (click)="toggleForSpecialItemDisplayBulkSubPopup()" checked="false"></span>
                                      </label>
                                    </div>
                                  </div>

                                  <div *ngIf="headerCompany === masterConstants.US_COMPANYCODE" [ngClass]="bulkChangesOnly === 'Y' ? 'col-4': 'col-6 padding-r0'">
                                    <div class="row">
                                      <div class="col-8" [ngClass]="bulkChangesOnly === 'Y' ? '': 'padding-l0 padding-r0'">
                                        DISPLAY: <b> {{displayText}}</b>
                                      </div>
                                      <section class="switch" [id]="manageSubscriptionDisplayItemToggle">
                                        <mat-slide-toggle class="example-margin" (click)="changeForManageSubscription()">
                                        </mat-slide-toggle>
                                      </section>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="displayInline row">
                              <div class="allItemsSection width-switch1 option" [ngClass]="bulkChangesOnly === 'Y' ? 'col-3': 'col-5'">
                                <div class="row">
                                  <div class="col-8">DISPLAY APR: <b> {{ bulkDisplayAPROnly == "Y" ? "ON" : "OFF" }}</b> </div>
                                  <label class="switch position-switch1">
                                    <input type="checkbox" checked>
                                    <span class="slider round" (click)="toggleForDisplayAprOnlyBulkSubPopup()" checked="false"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="btn-sec margin-t20">
                              <button mat-raised-button class="btns normal-large-btn margin-r15" (click)="SaveSubscribedUnsubscribedData();" color="primary">Yes</button>
                              <button mat-raised-button class="btns normal-large-btn" (click)="closeSubscribePopup()" color="primary">No</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-content smallSubsWindow" *ngIf="isUnSubsBtnModalShow" appClickOutside (clickOutside)="closeUnsubscribePopup()">
                        <div class="salesPersonOuter lessWidth">
                          <div class="tab-content-heading headtabPadding">
                            For: {{this.accountName}}
                          </div>
                          <div class="tab-content-detail">
                            <p>
                              Are you sure you want to
                              <span *ngIf="isSubscribeBulk" class="otherColor"> Subscribe </span>
                              <span *ngIf="!isSubscribeBulk" class="redColor"> Unsubscribe</span>
                              selected {{this.selectedCount}} user(s)?
                            </p>
                            <div *ngIf="isSubscribeBulk">
                              <div class="showChangesSection width-switch1">
                                <div class="toggleColor">
                                  <span class="padding-r10">SHOW CHANGES ONLY: <b> {{ bulkChangesOnly == "Y" ? "ON" : "OFF" }}</b> </span>
                                  <label class="switch">
                                    <input type="checkbox" (click)="toggleForchangesOnlyBulkUnSubPopup()" [checked]="bulkChangesOnly == 'Y'">
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </div>
                              <div class="allItemsSection width-switch2">
                                <div class="toggleColor">
                                  <span class="padding-r10">DISPLAY: <b> {{ bulkSubscriptionType == "C" ? "SPECIAL PRICED ITEMS" : "ALL ITEMS" }}</b> </span>
                                  <label class="switch position-switch2">
                                    <input type="checkbox" checked>
                                    <span class="slider round" (click)="toggleForSpecialItemDisplayBulkUnSubPopup()" checked="false"></span>
                                  </label>
                                </div>
                              </div>
                              <div class="allItemsSection width-switch1">
                                <div class="toggleColor">
                                  <span class="padding-r10">DISPLAY APR: <b> {{ bulkDisplayAPROnly == "Y" ? "ON" : "OFF" }}</b> </span>
                                  <label class="switch position-switch1">
                                    <input type="checkbox" checked>
                                    <span class="slider round" (click)="toggleForDisplayAprOnlyBulkSubPopup()" checked="false"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="btn-sec margin-t20">
                              <button mat-raised-button class="btns normal-large-btn margin-r15" (click)="SaveSubscribedUnsubscribedData();" color="primary">Yes</button>
                              <button mat-raised-button class="btns normal-large-btn" (click)="closeUnsubscribePopup()" color="primary">No</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-10 col-lg-10 col-xl-10 text-right toggleSection padding-0">
                <span class="text-left float-l margin-t5 blueText">
                  Email address is mandatory to subscribe to a price list. Contact WinField United customer service to update email address.
                </span>
                <div class="paginationSection">
                  <mat-paginator #productListPaginator [pageSize]="50" (page)="updatePage($event)"></mat-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomSection">
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer priceListTable" id="cppOrderView">
              <table mat-table #placedCPPOrdersTable [dataSource]="plManageSubDataSource" matSort matSortDirection="desc" multiTemplateDataRows class="matTables">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of plManageSubColumns">
                  <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
            </div>
            <div *ngIf="column=='userName'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="userName">User Name</th></div>
            <div *ngIf="column=='userId'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="userId">User Id</th></div>
            <div *ngIf="column=='email'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="email">Email</th></div>
            <div *ngIf="column=='showChanges'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="showChanges">Show Changes Only</th></div>
            <div *ngIf="column=='changeType'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="changeType">Change Type</th></div>
            <div *ngIf="column=='subscriptionType'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="subsType">Subscription Type</th></div>
            <div *ngIf="column=='displayAPR'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="displayAPR">DISPLAY APR</th></div>
            <div *ngIf="column=='status'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="status">Status</th></div>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="column=='checkbox'" class="text-center CheckBoxCol">
                <mat-checkbox #SingleCheck class="custom-checkbox"
                              (change)="enableCheckBoxSingle(SingleCheck._checked); element.isSelected=SingleCheck._checked;"
                              [(ngModel)]="element.isSelected"
                              [disabled]="element.isNonEditable"
                              [style.display]="'contents'"></mat-checkbox>
              </div>
              <div *ngIf="column=='userName'">
                <div class="order-info">
                  <p class="itemName">
                    {{element.userName}}
                  </p>
                </div>
              </div>
              <div *ngIf="column=='userId'">
                <div class="order-info">
                  <p class="itemName">
                    {{element.userId}}
                  </p>
                </div>
              </div>
              <div *ngIf="column=='email'">
                <div class="order-info">
                  <p class="itemName">
                    {{element.email}}
                  </p>
                </div>
              </div>
              <div *ngIf="column=='showChanges'">
                <div class="order-info">
                  <p class="itemName" *ngIf="element.status == 'SUBSCRIBED'">
                    {{element.showChanges}}
                  </p>
                </div>
              </div>
              <div *ngIf="column=='changeType'">
                <div class="order-info">
                  <p class="itemName" *ngIf="element.changeType">
                    {{element.changeType}}
                  </p>
                </div>
              </div>
              <div *ngIf="column=='subscriptionType'">
                <div class="order-info">
                  <p class="itemName" *ngIf="element.status == 'SUBSCRIBED'">
                    {{element.subscriptionType}}
                  </p>
                </div>
              </div>
              <div *ngIf="column=='displayAPR'">
                <div class="order-info">
                  <p class="itemName" *ngIf="element.status == 'SUBSCRIBED'">
                    {{element.displayAPR}}
                  </p>
                </div>
              </div>
              <div *ngIf="column=='status'">
                <div class="order-info">
                  <p *ngIf="element.status == 'SUBSCRIBED'" class="itemName subscribe">
                    {{element.status}}
                  </p>
                  <p *ngIf="element.status == 'UNSUBSCRIBED'" class="itemName un-subscribe">
                    {{element.status}}
                  </p>
                  <p *ngIf="element.status != 'UNSUBSCRIBED' && element.status != 'SUBSCRIBED'" class="itemName">
                    {{element.status}}
                  </p>
                </div>
              </div>
            </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="plManageSubColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: plManageSubColumns" id="tr_exp_{{element.rowNo}}"
                [ngClass]="{'disabledrow':element.isNonEditable}"></tr>
            </table>
            <div *ngIf="plManageSubDataSource == undefined || plManageSubDataSource?.data.length == 0" class="noDataMsg">
              <p>No Data Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
